"use client";

import { useState } from "react";
import {
  ChevronLeft,
  ChevronDown,
  Wallet,
  ShoppingCart,
  ChevronUp,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import BetSummaryPopup from "../../components/Popup/BetSummaryPopup";
import WalletPopup from "../../components/Popup/WalletPopup";

export default function KeypadHeader({ balance, cartCount = 0 }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState("");
  const [showSummary, setShowSummary] = useState(false)
  const [showPopup, setShowPopup] = useState(false);


  const GAMES = [
    "(3D) WIN-600",
    "(3D) WIN-660",
    "(3D) WIN-550",
    "(3D) POLAII-700",
    "STL LAPU-LAPU",
    "700/25% D: 700 T:450",
    "STL MIN(GENSAN) ",
    "3D 500/45",
    "EZ2",
    "S2 -Win70",
    "LAST 3 (SK)",
    "S2 (SK)",
    "LAST 2 (SK)",
    "WIN 700",
    "3D 450/50",
    "STL BUKIDNON",
    "STL MISOR (GEN)",
    "STL CDO",
    "PICK 3",
  ];


  const [bets, setBets] = useState([
    { id: '1', combination: '151', type: 'T', amount: 10.00 },
    { id: '2', combination: '361', type: 'T', amount: 10.00 },
    { id: '3', combination: '316', type: 'T', amount: 6.00 },
    { id: '4', combination: '316', type: 'R', amount: 6.00 }
  ])

  const handleRemoveBet = (id) => {
    setBets(bets.filter(bet => bet.id !== id))
  }

  const handleSubmit = () => {
    console.log('Submitting bets:', bets)
    setShowSummary(false)
  }



const navigate = useNavigate();

  return (
<>
    <header className="flex items-center justify-between  bg-[#1e3a8a] px-3 pt-6">
      <div className="flex items-center gap-2 relative">
        <Link href="/games" className="text-white">
          <ChevronLeft className="h-6 w-6" onClick={()=>navigate(-1)}/>
        </Link>
        <button
          id="dropdownButton"
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-1 text-white "
        >
          <span className="font-medium text-sm">
            {" "}
            {selectedGame || "(3D) WIN-600"}{" "}
          </span>
          {dropdownOpen ? (
            <ChevronUp className="h-4 w-4" /> // ChevronUp icon for open state
          ) : (
            <ChevronDown className="h-4 w-4" /> // ChevronDown icon for closed state
          )}{" "}
        </button>

        {dropdownOpen && (
          <ul className="absolute top-5 left-2 z-10 mt-1 bg-white border rounded-md shadow-md">
            {GAMES.map((game, index) => (
              <li
                key={game}
                onClick={() => {
                  setSelectedGame(game);
                  setDropdownOpen(false);
                }}
                className={`p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer ${
                  index !== 0 ? "border-t border-[#E1E7EF]" : ""
                }`}
              >
                {game.toUpperCase()}
              </li>
            ))}
          </ul>
        )}



        
      </div>

      <div className="flex items-center gap-3">
        <button className="flex items-center justify-between gap-1 text-white px-1 py-0.5 rounded-lg text-sm font-semibold border"
                  onClick={() => setShowPopup(true)}
        
        >
          <Wallet className="h-4 w-4" />
          <span className="ps-1">₱ {balance.toLocaleString()}</span>
        </button>
        <div className="relative " onClick={() => setShowSummary(true)}>
          <ShoppingCart className="h-6 w-6 text-white"  />
          {cartCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-green-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
              {cartCount}
            </span>
          )}
        </div>
      </div>
    </header>


    <BetSummaryPopup 
        isOpen={showSummary}
        onClose={() => setShowSummary(false)}
        drawTime="2:00 PM"
        drawDate="Oct 02, 2024"
        bets={bets}
        onRemoveBet={handleRemoveBet}
        onSubmit={handleSubmit}
      />


       <WalletPopup
              isOpen={showPopup}
              onClose={() => setShowPopup(false)}
              currentBalance={17248}
            />

</>

  );
}
